import { RiMoonClearLine } from "@remixicon/react";
import React, { ReactElement, useState } from "react";
import { ChatStatus, useSnoozeMutation } from "../../../__generated__/api";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import useSelectionState from "../../../contexts/selection-state/SelectionStateContext";
import { Ticket } from "../../../contexts/selection-state/selection-state";
import { useRegisterAction, useTicketState } from "../../../contexts/ticket-state";
import {
    ActionContext, ActionHandler, ActionType, HANDLER_INTERFACE,
} from "../../../contexts/ticket-state/action-registry";
import Scheduler from "../../scheduler/Scheduler";

export default function Snooze(): ReactElement {
    const selectionState = useSelectionState();
    const [sendSnooze] = useSnoozeMutation();
    const [isShow, setShouldShow] = useState(false);
    const ticketContext = useTicketState();

    const [lastIgnored, setLastIgnored] = useState<Ticket[]>([]);
    const [actionHandler, setActionHandler] = useState<ActionHandler>();

    const snooze = (tickets?: Ticket[]) => {
        const selection = tickets
            ?? ticketContext?.selectionState.current?.toIdList("chat")
            ?? selectionState
                .getSelection()
                .filter(ticket => ticket.status === ChatStatus.Assigned);

        setLastIgnored(selection);
        setShouldShow(true);
    };

    const doSnooze = async (date: Date, note: string) => {
        actionHandler?.items.forEach(row => {
            row.setStatusLocal(ChatStatus.Snoozed);
            row.closeIfOpen();
        });
        actionHandler?.done();
        const ids = lastIgnored.toIdList("id") as string[];
        await sendSnooze({
            variables: {
                ids,
                options: {
                    note,
                    date,
                },
            },

        });
        setShouldShow(false);
        selectionState.closeCurrent();
    };

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "k+s",
            context: "default",
            description: "Snooze the conversation",
            group: "Conversations",
            handler: () => {
                snooze();
                setActionHandler(ticketContext?.selectionState.createActionHandler(ActionContext.BULK_ACTION));
            },
        });
    });

    useRegisterAction({
        createBulkActionButton() {
            return {
                text: "Snooze",
                icon: <RiMoonClearLine />,
                variant: "ghost-gray",
            };
        },
        handleBulkAction(handler) {
            snooze(handler.items.map(row => row.chat));
            setActionHandler(handler);
        },
    }, ActionType.SNOOZE);

    selectionState.registerSnooze(tickets => {
        snooze(tickets);
    });

    return (
        <div>
            <Scheduler
                confirmText="Snooze"
                shouldShow={isShow}
                title="Snooze Ticket"
                previewText="Ticket will snoozed until"
                isPresetAutoSelect={false}
                onCancel={() => {
                    actionHandler?.rollback();
                    setShouldShow(false);
                }}
                canAddNotes
                onSelected={(date, _timezone, notes) => doSnooze(date, notes)}
            />
        </div>
    );
}

HANDLER_INTERFACE.register(Snooze);

Snooze.defaultProps = {
    refreshData: () => {
        // nothing
    },
};
